import type { IMasterDataRetailerRepository } from "@src/domain/repositories/masterData";
import type { CreateMasterDataRetailerDTO } from "@src/domain/dto/masterData";

export class CreateMasterDataRetailerUseCase {
  private readonly repository: IMasterDataRetailerRepository;

  constructor(repository: IMasterDataRetailerRepository) {
    this.repository = repository;
  }

  execute(params: CreateMasterDataRetailerDTO) {
    return this.repository.createRetailer(params);
  }
}
